<template>
  <div>
    <el-header>
      <h3 class="title">
        <div class="block">
          <span>微博接入</span>
        </div>
      </h3>
    </el-header>
    <el-container>
      <el-main>
        <el-row type="flex" justify="center">
          <el-col class="max-block" :span="17">
            <el-steps :active="active" finish-status="success" align-center>
              <el-step title="微博基本信息"></el-step>
              <el-step title="接口生成"></el-step>
              <el-step title="填写access-token"></el-step>
              <el-step title="微博客服配置"></el-step>
            </el-steps>
            <div v-if="active == 0">
              <el-form size="medium" label-width="250px">
                <el-form-item label="添加微博名称:">
                  <el-input></el-input>
                </el-form-item>
                <el-form-item label="微博账号ID:">
                  <el-input></el-input>
                </el-form-item>
                <el-form-item style="margin-top: 50px">
                  <el-row type="flex" justify="center">
                    <el-button @click="cancel">取 消</el-button>
                    <el-button type="primary" @click="nextStep">下一步</el-button>
                  </el-row>
                </el-form-item>
              </el-form>
            </div>
            <div v-if="active == 1">
              <el-form size="medium" label-width="250px">
                <el-form-item label="URL:">
                  <el-input></el-input>
                </el-form-item>
                <el-form-item label="APPKEY:">
                  <el-input></el-input>
                </el-form-item>
                <el-form-item style="margin-top: 50px">
                  <el-row type="flex" justify="center">
                    <el-button @click="cancel">取 消</el-button>
                    <el-button type="primary" @click="prevStep(active)">上一步</el-button>
                    <el-button type="primary" @click="nextStep">下一步</el-button>
                  </el-row>
                </el-form-item>
              </el-form>
            </div>
            <div v-if="active == 2">
              <el-form size="medium" label-width="250px">
                <el-form-item label="填写access-token:">
                  <el-input></el-input>
                </el-form-item>
                <el-form-item style="margin-top: 50px">
                  <el-row type="flex" justify="center">
                    <el-button @click="cancel">取 消</el-button>
                    <el-button type="primary" @click="prevStep(active)">上一步</el-button>
                    <el-button type="primary" @click="nextStep">下一步</el-button>
                  </el-row>
                </el-form-item>
              </el-form>
            </div>
            <div v-if="active == 3">
              <el-form size="medium" label-width="250px">
                <el-form-item label="启用智能机器人:">
                  <el-select>
                    <el-option
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="是否开启触发词命中转人工">
                  <el-radio-group>
                    <el-radio label="是"></el-radio>
                    <el-radio label="否"></el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="转人工触发:">
                  <el-input placeholder="例如：人工，转人工"></el-input>
                  <el-tooltip class="item" content="1.可设置多个，多个触发词用英文逗号隔开：2.需要全部命中触发词，如：触发词为”转人工“则必须输入”转人工“才能转入人工" placement="right">
                    <el-button
                      type="text"
                      size="small"
                    >
                      <svg class="icon icon-warning" aria-hidden="true">
                        <use xlink:href="#icontixing" />
                      </svg>
                    </el-button>
                  </el-tooltip>
                </el-form-item>
                <el-form-item label="欢迎语:">
                  <el-input type="textarea"></el-input>
                </el-form-item>
                <el-form-item label="路由策略:">
                  <el-select>
                    <el-option
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item style="margin-top: 50px">
                  <el-row type="flex" justify="center">
                    <el-button @click="cancel">取 消</el-button>
                    <el-button type="primary" @click="prevStep(active)">上一步</el-button>
                    <el-button type="primary" @click="nextStep">保 存</el-button>
                  </el-row>
                </el-form-item>
              </el-form>
            </div>
          </el-col>
        </el-row>
      </el-main>
    </el-container>

    <el-dialog
      width="480px"
      :visible.sync="artificialDialog"
      class="dialog-artificial"
    >
      <el-form>
        <el-form-item label="标题">
          <el-input placeholder="标题不能超过60个字符"></el-input>
        </el-form-item>
        <el-form-item label="封面">
          <el-upload>
            <div class="el-upload__tip">（大图片建议尺寸：900像素 * 500像素）</div>
            <el-row type="flex" justify="space-between" style="margin-left: -40px;">
              <el-button size="small" type="info">图片上传</el-button>
            </el-row>
          </el-upload>
        </el-form-item>
        <el-form-item label="摘要">
          <el-input type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="选择正文编辑方式" class="choice-content">
          <el-button style="width: 100%">秀米图文助手</el-button>
          <el-button style="width: 100%">链接到网页</el-button>
          <el-button style="width: 100%">手工编辑</el-button>
        </el-form-item>
      </el-form>
      <el-row type="flex" justify="center" style="margin-top: 10px">
        <el-button size="medium">预 览</el-button>
        <el-button type="primary" size="medium" @click="dialogVisible = false">保 存</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import imageText from './imageText'
import textContent from './textContent'
export default {
  name: 'codeAuthorize',
  data() {
    return {
      active: 0,
      activeName: 'first',
      menuContent: '发送消息',
      // 弹窗
      artificialDialog: false
    }
  },
  props: {
    wxappListFlag: Boolean
  },
  components: {
    imageText,
    textContent
  },
  mounted() {
  },
  methods: {
    changeActive(num) {
      this.artificialDialog = true
    },
    handleClick(tab, event) {
      // console.log(tab, event)
    },
    cancel() {
      this.$emit('changeView', !this.wxappListFlag)
    },
    prevStep (active) {
      if (active < this.active) {
        this.active = active
      }
    },
    nextStep() {
      if (this.active++ > 2) this.active = 0
    }
  }
}
</script>
<style lang="scss" scoped>
  .el-header {
    padding: 0;
    margin-bottom: 0;
    .title {
      margin-bottom: 0;
    }
  }

  .max-block {
    max-width: 800px;
    h4 {
      text-align: center;
      font-size: 20px;
      color: #333;
      margin-bottom: 35px;
    }
    .el-form {
      margin-top: 50px;
    }
    .el-form-item {
      ::v-deep .el-form-item__label {
        color: #333;
      }
      ::v-deep .el-form-item__content {
        .el-input,
        .el-textarea,
        .el-select {
          width: 75%;
          margin-right: 10px;
        }
        .el-select {
          .el-input {
            width: 100%;
          }
        }
        .el-row {
          width: 75%;
          .el-input,
          .el-textarea,
          .el-select {
            width: 100%;
            margin-right: 0;
          }
        }
      }
    }
    ::v-deep .el-form-item__content {
      .d-flex {
        display: flex;
        margin-bottom: 20px;
        .el-row {
          margin-right: 10px;
        }
        .el-button {
          & + .el-button {
            margin-left: 10px;
          }
        }
      }
    }
  }

  .menu-custom {
    display: flex;
    margin-top: 40px;
    margin-bottom: 50px;
    display: flex;
    justify-content: center;

    .menu-demo {
      position: relative;
      width: 290px;
      flex-basis: 290px;
      height: 518px;
      margin-right: 20px;
      border: 1px solid #e9e9e9;

      .menu-demo-bottom {
        display: flex;
        align-items: center;
        position: absolute;
        bottom: 0;
        width: 100%;
        border-top: 1px solid #e9e9e9;
        box-sizing: border-box;

        .keybord {
          flex-basis: 46px;
          display: flex;
          -webkit-box-pack: center;
          justify-content: center;
          -webkit-box-align: center;
          align-items: center;
          width: 34px;
          height: 42px;
          background-color: #f8f8f8;

          .icon {
            font-size: 24px;
          }
        }

        ul {
          display: flex;
          align-items: center;
          width: calc(100% - 34px);
          height: 42px;
          background-color: #f8f8f8;

          li {
            width: 33.33%;
            height: 100%;
            line-height: 42px;
            border-left: 1px solid #e9e9e9;
            text-align: center;
          }
        }
      }
    }
    .menu-container {
      flex: 1;
      border: 1px solid #e9e9e9;

      .menu-title {
        height: 45px;
        line-height: 45px;
        padding: 0 20px;
        font-size: 14px;
        text-align: left;
        border-bottom: 1px solid #e9e9e9;
      }
      .menu-content {
        padding: 20px;

        .el-form-item {
          margin-bottom: 10px;
        }
        // tab
        .el-tabs--card {
          ::v-deep .el-tabs__header {
            margin-bottom: 0;

            .el-tabs__nav {
              &:first-child {
                margin-left: -1px;
              }
              .el-tabs__item {
                min-width: 100px;
                text-align: center;
                margin-right: 4px;
                border-radius: 5px 5px 0 0;
                background-color: #f7f7fa;
                color: #333;
                border: 1px solid transparent;
                border-bottom-color: #e9e9e9;
                &.is-active {
                  color: #337eff;
                  background-color: #fff;
                  border: 1px solid #e9e9e9;
                  border-bottom-color: transparent;
                }
              }
            }
          }
          ::v-deep .el-tabs__content {
            border-left: 1px solid #e9e9e9;
            border-right: 1px solid #e9e9e9;
          }
        }

        .block-bottom {
          height: 40px;
          line-height: 40px;
          border: 1px solid #e9e9e9;

          .right-list {
            float: right;

            li {
              float: left;
              border-left: 1px solid #e9e9e9;
              padding: 0 15px;
              color: #6b6b6b;
              cursor: pointer;

              &:hover {
                color: #337eff;
              }

              .icon {
                font-size: 16px;
                margin-right: 5px;
              }
            }
          }
        }
      }
    }
  }
  .el-tooltip__popper {
    max-width: 100px;
  }

  .menu-other {
    border: 1px solid #e9e9e9;
    border-bottom: none;
    border-radius: 5px 5px 0 0;
    .other-title {
      height: 42px;
      line-height: 42px;
      padding: 0 15px;
      font-size: 14px;
      color: #333;
      background-color: #f7f7fa;
      border-radius: 5px 5px 0 0;
    }
    .other-content {
      min-height: 200px;
      padding: 10px 0;
      .other-explain {
        padding-left: 15px;
        margin-bottom: 15px;
        font-size: 14px;
      }
      ::v-deep .el-form-item {
        .el-input {
          width: 80%;
          margin-right: 10px;
        }
      }
    }
  }

  .dialog-artificial {
    ::v-deep .el-dialog__body {
      padding: 10px 40px 30px;
      .el-form-item {
        margin-bottom: 5px;
      }
      .el-upload {
        .el-upload__tip {
          margin-top: 0;
        }
      }
      .choice-content {
        .el-button {
          margin-bottom: 10px;
          & + .el-button {
            margin-left: 0;
          }
        }
      }
    }
  }
</style>
